import { useConfig } from '../../config';
import styles from './BottomMenu.module.scss';
import MenuItem from './MenuItem';

const BottomMenu = () => {
  const config = useConfig('config.siteConfig.bottomMenu');

  return (
    <div className={styles['bottom-menu']}>
      {config?.items.map((item) => (
        <MenuItem key={item.id} {...item} />
      ))}
    </div>
  );
};

export default BottomMenu;
